"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABS_CHANGE_TAB_TYPE = void 0;
const TABS_CHANGE_TAB_TYPE = exports.TABS_CHANGE_TAB_TYPE = 'tabs/changeTab';